import './App.css';
import ApiIntegration from './ApiIntegration';
import Header from './Header';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <ApiIntegration />
      <Footer />
    </div>
  );
}

export default App;
